import { IAbstractRecord } from '@models';
import PrecisionService from '@services/PrecisionService';
import { isValidNumber } from '@utils/validationUtils';

export function extractAssignedBPWithPagination(data: any) {
  const assignedBP: Record<string, string> = {};

  data.SalesforceManagement.queries.getAssignedBPList.items.forEach(
    (element: {
      businessPartner_Id: string;
      salesforceManagement_AssignedBP_BusinessPartnerID: {
        views: {
          SalesforceManagement_all: {
            properties: {
              Code: string;
              PersonID: {
                views: {
                  SalesforceManagement_all: {
                    properties: {
                      FullName: string;
                    };
                  };
                };
              };
            };
          };
        };
      };
    }) => {
      assignedBP[element.businessPartner_Id] =
        `${element.salesforceManagement_AssignedBP_BusinessPartnerID.views.SalesforceManagement_all.properties.Code} - ${element.salesforceManagement_AssignedBP_BusinessPartnerID.views.SalesforceManagement_all.properties.PersonID.views.SalesforceManagement_all.properties.FullName}`;
    }
  );

  return assignedBP;
}

export function extractLines(data: any) {
  const lines: Record<string, string> = {};

  data?.SalesforceManagement?.queries?.getDistinctAssignedBPLineListWithoutPagination.forEach(
    (obj: IAbstractRecord) => {
      const lineInfo = obj.salesforceManagement_AssignedBPPlan_LineID;
      lines[lineInfo.id] =
        `${lineInfo.views.PlanConfigManagement_all.properties.ExternalCode} - ${lineInfo.views.PlanConfigManagement_all.properties.Name}`;
    }
  );

  return lines;
}

export const transformToShare = (value: string | number) => {
  return isValidNumber(value) ? PrecisionService.divideBy100(Number(value)) : 0;
};

export function extractSublines(data: any) {
  const sublines: Record<string, string> = {};

  data?.SalesforceManagement?.queries?.getActiveAssignedBPPlanList?.items?.forEach(
    (element: {
      subline_Id: string;
      salesforceManagement_AssignedBPPlan_PlanID: {
        views: {
          PlanConfigManagement_all: {
            properties: {
              SublineID: {
                views: {
                  PlanConfigManagement_all: {
                    properties: {
                      Name: string;
                      ExternalCode: string;
                    };
                  };
                };
              };
            };
          };
        };
      };
    }) => {
      sublines[element.subline_Id] =
        `${element.salesforceManagement_AssignedBPPlan_PlanID.views.PlanConfigManagement_all.properties.SublineID.views.PlanConfigManagement_all.properties.ExternalCode} - ${element.salesforceManagement_AssignedBPPlan_PlanID.views.PlanConfigManagement_all.properties.SublineID.views.PlanConfigManagement_all.properties.Name}`;
    }
  );

  return sublines;
}

export function extractPlans(data: any) {
  const plans: Record<string, string> = {};
  const planCurrencies: Record<string, string> = {};

  data?.SalesforceManagement?.queries?.getActiveAssignedBPPlanList?.items?.forEach(
    (element: {
      plan_Id: string;
      salesforceManagement_AssignedBPPlan_PlanID: {
        views: {
          PlanConfigManagement_all: {
            properties: {
              Name: string;
              ExternalCode: string;
              PlanCurrency: {
                Code: string;
              };
            };
          };
        };
      };
    }) => {
      plans[element.plan_Id] =
        `${element.salesforceManagement_AssignedBPPlan_PlanID.views.PlanConfigManagement_all.properties.ExternalCode} - ${element.salesforceManagement_AssignedBPPlan_PlanID.views.PlanConfigManagement_all.properties.Name}`;

      planCurrencies[element.plan_Id] =
        element.salesforceManagement_AssignedBPPlan_PlanID.views.PlanConfigManagement_all.properties.PlanCurrency?.Code;
    }
  );

  return { plans, planCurrencies };
}

export function extractPlanAssignBPPlan_Id(data: any) {
  const lines: Record<string, string> = {};

  data?.SalesforceManagement?.queries?.getActiveAssignedBPPlanList?.items?.forEach(
    (element: {
      plan_Id: string;
      salesforceManagement_AssignedBPPlan_Id: string;
    }) => {
      lines[element.plan_Id] = element.salesforceManagement_AssignedBPPlan_Id;
    }
  );

  return lines;
}
